import { oauthProviderClient } from '@better-auth/oauth-provider/client'
import type { QueryClient } from '@tanstack/react-query'
import { usernameClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import { onUnauthorized } from '../api/client'

/**
 * Better Auth client; the API serves it under `/api/auth` on the same origin.
 * On a page an assistant's sign-in passes through (`/login`, `/connect`: signed query in the address), every request
 * carries that query, so the OAuth flow goes on afterwards (`oauthProviderClient`, docs/mcp.md)
 */
export const authClient = createAuthClient({ plugins: [usernameClient(), oauthProviderClient()] })

export const meQueryKey = ['me'] as const

/**
 * A request turned away for the session (401, or the session waiting for its PIN) asks again who is signed in, once:
 * not while that is being asked already. Asking again then would cancel the request on its way, and its own refusal
 * ask again, for ever: the app would never settle to show sign-in or the PIN. `/api/me` alone: the pages' own
 * `['me', …]` queries under the lock would be refused again, and ask again. → stop listening
 */
export const refreshMeOnUnauthorized = (client: QueryClient) =>
  onUnauthorized(() => {
    const me = { queryKey: meQueryKey, exact: true }
    if (!client.isFetching(me)) client.invalidateQueries(me)
  })
